import { updateOrganizationDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const updateOrganizationCallable = getCallable(
  updateOrganizationDefinition,
);
